<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Cuentas" resource="cuentas" primaryKey="idcuenta"
        :records="records" :meta="meta" :columns="columns" />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import CuentaService from "@/services/cuenta.service";
import { cuenta } from "@/models/cuenta";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: cuenta.filter(column => column.showOnList)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        CuentaService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
